import { TTrainingVideoItem } from '../types/TTrainingVideoItem';

export const filterVideosByFolder = (videos: TTrainingVideoItem[], folder: string) =>
  videos.filter((video) => video.path.includes(`/${folder}/`));
